import { render, staticRenderFns } from "./ShDialog.md?vue&type=template&id=15b2fba0"
import script from "./ShDialog.md?vue&type=script&lang=js"
export * from "./ShDialog.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports